/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

// import Components
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import SCCL from '../assets/images/commons/scclLogo.svg';
import withRouter from 'Components/Common/withRouter';
import { AuthUser, encrypt, getLoginUserMenuRoutes } from 'Components/Common/Util';
import { store } from 'slices/persister';
import Navdata from './LayoutMenuData';
import { APIClient } from 'helpers/api_helper';
import { useDispatch } from 'react-redux';
import { addDepartmentOptions } from 'slices/auth/login/reducer';



const Header = (props: any) => {
    const [search, setSearch] = useState<boolean>(false);
    const navData = Navdata().props.children;

    const userDetails = AuthUser();
    const toogleSearch = () => {
        setSearch(!search);
    };
    const dispatch = useDispatch()

    const backOrHomePage = () => {
        let role;
        let privileges;
        if (userDetails?.userProfile?.roles?.length > 1) {
            role = store?.getState()?.SelectedRole?.role?.role;
            privileges = store?.getState()?.SelectedRole?.role?.privileges;
        } else {
            role = userDetails?.userProfile?.roles?.[0]?.role;
            privileges = userDetails?.userProfile?.roles?.[0]?.privileges;
        }

        if (role?.toLowerCase() === 'user') {
            props?.router?.navigate('/clientAreaDashboard');
        } else if (role?.toLowerCase() === 'guest') {
            props?.router?.navigate('/clientMap', { state: { header: 'hide' } });
        } else {
            const menuRoutes = getLoginUserMenuRoutes(privileges, navData);
            const firstRoute = menuRoutes?.[0];
            props?.router?.navigate(firstRoute?.link);
        }
    };

    useEffect(() => {
        const apiClient = new APIClient(process.env.REACT_APP_API_URL || '');

        apiClient.get(`departments/fetch`)
            .then((res: { data: any }) => {
                if (res?.data?.data) {
                    dispatch(addDepartmentOptions(res?.data?.data))
                }
            })
            .catch((err: any) => {
                console.error("Error fetching departments:", err);
            });
    }, [])
    return (
        <React.Fragment>
            <header id="page-topbar" className={props.headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex align-items-center">
                            <div className="navbar-brand-box" onClick={() => backOrHomePage()}>
                                {/* <Link to="/" className="logo logo-dark"> */}
                                <Link to="" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={SCCL} alt="" height="50" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={SCCL} alt="" height="50" />
                                    </span>
                                </Link>

                                <Link to="" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={SCCL} alt="" height="50" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={SCCL} alt="" height="50" />
                                    </span>
                                </Link>
                            </div>
                            <div className="d-flex flex-column justify-content-between " style={{ height: 50 }}>
                                <span className="logo-title">The Singareni Collieries Company Limited</span>
                                <span className="logo-desc primary"> (A Government Company)</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle
                                    type="button"
                                    tag="button"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                >
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search ..."
                                                    aria-label="Recipient's username"
                                                />
                                                <button className="btn btn-primary" type="submit">
                                                    <i className="mdi mdi-magnify"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            {/* <LightDark layoutMode={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} /> */}

                            {/* NotificationDropdown */}
                            {/* <NotificationDropdown /> */}

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default withRouter(Header);
